// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1800":"de2511b816c844ef","8178":"30a0f5b7ed7806b9"}[chunkId] + ".css";
};